import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

interface CreatePostHeaderProps {
  onSubmit: () => void;
  disabled?: boolean;
  submitText?: string;
}

export const CreatePostHeader: React.FC<CreatePostHeaderProps> = ({ onSubmit, disabled, submitText }) => {
  const navigate = useNavigate();

  return (
    <div className="w-full h-14 p-4 flex justify-between items-center bg-[#FBF6F1]">
      <button
        onClick={() => navigate(-1)}
        className="size-7 flex items-center justify-center"
      >
        <ChevronLeft className="w-6 h-6 text-[#1E3A3A]" />
      </button>
      <div className="text-[#1E3A3A] text-base font-medium font-manrope leading-tight">
        {submitText === 'Chỉnh sửa' ? 'Chỉnh sửa bài viết' : 'Tạo bài viết'}
      </div>
      <button
        className={`text-[#6F6F6B] text-sm font-normal font-sora leading-tight ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        onClick={onSubmit}
        disabled={disabled}
      >
        {submitText || 'Đăng'}
      </button>
    </div>
  );
}; 